var _style, _g, _g2, _polygon, _path, _path2, _defs, _polygon2, _line, _line2, _polyline, _line3, _path3, _path4, _path5, _polygon3, _path6, _path7, _polygon4, _path8, _path9, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMerrychefeikonE2S(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;fill:none;stroke:#808080;stroke-miterlimit:10;}\n\t.st3{opacity:0.3;fill:#808080;}\n\t.st4{fill:none;stroke:#808080;stroke-miterlimit:10;}\n\t.st5{fill:#808080;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#808080;stroke-width:2;stroke-miterlimit:10;}\n\t.st9{fill:#4C4C4C;}\n\t.st10{fill:#0AAEFF;}\n\t.st11{fill:url(#SVGID_3_);}\n\t.st12{display:inline;fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 250,
    cy: 250,
    r: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 250,
    x2: 500,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250,
    y1: 500,
    x2: 250,
    y2: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "224.5,32.4 103.3,102.4 103.3,422.1 273.8,467.8 395.1,397.8 395.1,78.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "229.9,63.3 69.2,156.2 69.2,384.9 268.4,438.7 429.1,345.8 429.1,117.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "197.5,114.6 40.7,205.2 40.7,314.7 302.5,385.4 459.3,294.8 459.3,185.3  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M326.1,160.7l-106.1-28.4l-70.3,40.6c-3.2,1.8-5.2,5.3-5.2,8.9v62.4l-5.1,3c-1.2,0.7-1.6,1.8-1.6,2.9h0v11.3 c0.1,1.3,1,2.6,2.5,3l4.1,1.1v96.7l5.6,1.5v4.5l100.5,26.9l70-40.4v-4.6l5.4-3.1V160.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "118.6,419.8 280.2,463.1 392.7,398.1 392.7,370.8 118.6,354.8  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M372.2,386.8c2.6-1.5,5.9,0.4,5.9,3.4v5.1l4.6,1.2l15.8-9.1l-15.6-7.1L372.2,386.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M230.8,40.4l-112.9,65.2c-5.1,3-8.3,8.4-8.3,14.4v290.1l170.5,45.7l25.5-14.7V438c0-5.8,3.1-11.1,8.1-13.9 l63.2-36.5c2.6-1.5,5.9,0.4,5.9,3.4v5.6l18.6-10.7V86.1L230.8,40.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M401.3,86.1l-113,65.3c-5.1,2.9-8.2,8.3-8.2,14.2v290.2l-170.5-45.7V118.9c0-5.3,2.8-10.1,7.4-12.8 l113.9-65.7L401.3,86.1z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "116.9,106.1 288.3,151.3 401.3,86.1 230.8,40.4  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 109.5,
    y1: 238.5,
    x2: 280.1,
    y2: 284.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 280.1,
    y1: 407.1,
    x2: 109.5,
    y2: 361.3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "118.8,105 289.3,150.7 289.3,450.4  "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 289.3,
    y1: 401.7,
    x2: 280.1,
    y2: 407.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.8,261v-74.7c0-10.9-7.3-20.5-17.9-23.3l-99.7-26.7c-8.2-2.2-16.2,4-16.2,12.4v76.5L261.8,261z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M261.8,280.3v27.1c0,8.5-8.2,14.7-16.4,12.4l-99.9-28.3c-10.4-2.9-17.5-12.4-17.5-23.2v-25.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M257.9,316.5c-2.2,0.6-4.5,0.6-6.9,0l-99.9-28.3c-10.4-2.9-17.5-12.4-17.5-23.2v-25.9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "280.1,265.9 401.3,195.9 401.3,214.2 280.1,284.2  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M280.1,265.9v18.2l-8,4.6c-6.6,3.8-14.4,5.1-21.9,3.5l-147.2-39.5c-2.5-0.5-3.9-2.6-4.1-4.8v-18.2h0c0-1.9,0.7-3.6,2.6-4.7 l8.1-4.9L280.1,265.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M102.9,234.6L250.1,274c7.5,1.6,15.3,0.4,21.9-3.5l8-4.6l0,0l-10.2-2.7l-4.4,2.6c-4.4,2.6-9.6,3.4-14.6,2.3 l-137.4-37.4c-1.8-0.4-2.2-2.8-0.5-3.7l7-4.1l-10.3-2.8l-8.1,4.9c-1.9,1.1-2.7,2.9-2.6,4.7C99,232,100.4,234,102.9,234.6z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "167,169.7 222.7,184.8 222.7,221.8 167,206.7  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5,376.8c0,1.5-1.1,2.4-2.4,2s-2.4-1.9-2.4-3.4s1.1-2.4,2.4-2C127.4,373.9,128.5,375.4,128.5,376.8z M133.7,375.5 c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2S135,375.9,133.7,375.5z M141.3,377.6c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4 c1.4,0.4,2.4-0.5,2.4-2S142.7,378,141.3,377.6z M148.9,379.7c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2 S150.3,380,148.9,379.7z M156.6,381.7c-1.4-0.4-2.4,0.5-2.4,2c0,1.5,1.1,3,2.4,3.4s2.4-0.5,2.4-2 C159,383.6,157.9,382.1,156.6,381.7z M164.2,383.8c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2S165.6,384.1,164.2,383.8z  M171.8,385.8c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S173.2,386.2,171.8,385.8z M179.5,387.9 c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S180.8,388.2,179.5,387.9z M187.1,389.9c-1.4-0.4-2.4,0.5-2.4,2 s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S188.5,390.3,187.1,389.9z M194.7,392c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2 S196.1,392.3,194.7,392z M202.4,394c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S203.7,394.4,202.4,394z  M210,396.1c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S211.4,396.5,210,396.1z M217.6,398.1 c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S219,398.5,217.6,398.1z M225.3,400.2c-1.4-0.4-2.4,0.5-2.4,2 s1.1,3,2.4,3.4s2.4-0.5,2.4-2S226.6,400.6,225.3,400.2z M232.9,402.3c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2 S234.3,402.6,232.9,402.3z M240.6,404.3c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S241.9,404.7,240.6,404.3z  M248.2,406.4c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S249.5,406.7,248.2,406.4z M126,381.8 c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S127.4,382.2,126,381.8z M133.7,383.9c-1.4-0.4-2.4,0.5-2.4,2 s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2C136.1,385.7,135,384.2,133.7,383.9z M141.3,385.9c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4 s2.4-0.5,2.4-2S142.7,386.3,141.3,385.9z M148.9,388c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2 S150.3,388.3,148.9,388z M156.6,390c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S157.9,390.4,156.6,390z  M164.2,392.1c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S165.6,392.5,164.2,392.1z M171.8,394.1 c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2S173.2,394.5,171.8,394.1z M179.5,396.2c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4 c1.4,0.4,2.4-0.5,2.4-2S180.8,396.6,179.5,396.2z M187.1,398.2c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2 S188.5,398.6,187.1,398.2z M194.7,400.3c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S196.1,400.7,194.7,400.3z  M202.4,402.4c-1.4-0.4-2.4,0.5-2.4,2c0,1.5,1.1,3,2.4,3.4s2.4-0.5,2.4-2S203.7,402.7,202.4,402.4z M210,404.4 c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2S211.4,404.8,210,404.4z M217.6,406.5c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4 c1.4,0.4,2.4-0.5,2.4-2S219,406.8,217.6,406.5z M225.3,408.5c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2 S226.6,408.9,225.3,408.5z M232.9,410.6c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S234.3,410.9,232.9,410.6z  M240.6,412.6c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2S241.9,413,240.6,412.6z M248.2,414.7c-1.4-0.4-2.4,0.5-2.4,2 s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S249.5,415,248.2,414.7z M126,390.1c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4 c1.4,0.4,2.4-0.5,2.4-2S127.4,390.5,126,390.1z M133.7,392.2c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2 S135,392.6,133.7,392.2z M141.3,394.2c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S142.7,394.6,141.3,394.2z  M148.9,396.3c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2S150.3,396.7,148.9,396.3z M156.6,398.4c-1.4-0.4-2.4,0.5-2.4,2 s1.1,3,2.4,3.4s2.4-0.5,2.4-2S157.9,398.7,156.6,398.4z M164.2,400.4c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2 S165.6,400.8,164.2,400.4z M171.8,402.5c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S173.2,402.8,171.8,402.5z  M179.5,404.5c-1.4-0.4-2.4,0.5-2.4,2c0,1.5,1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2C181.9,406.4,180.8,404.9,179.5,404.5z  M187.1,406.6c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2S188.5,406.9,187.1,406.6z M194.7,408.6c-1.4-0.4-2.4,0.5-2.4,2 s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S196.1,409,194.7,408.6z M202.4,410.7c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4 c1.4,0.4,2.4-0.5,2.4-2S203.7,411,202.4,410.7z M210,412.7c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2 S211.4,413.1,210,412.7z M217.6,414.8c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2S219,415.1,217.6,414.8z M225.3,416.8 c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S226.6,417.2,225.3,416.8z M232.9,418.9c-1.4-0.4-2.4,0.5-2.4,2 s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S234.3,419.3,232.9,418.9z M240.6,420.9c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4 c1.4,0.4,2.4-0.5,2.4-2S241.9,421.3,240.6,420.9z M248.2,423c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2 S249.5,423.4,248.2,423z M126,398.5c-1.4-0.4-2.4,0.5-2.4,2c0,1.5,1.1,3,2.4,3.4s2.4-0.5,2.4-2S127.4,398.8,126,398.5z  M133.7,400.5c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2S135,400.9,133.7,400.5z M141.3,402.6c-1.4-0.4-2.4,0.5-2.4,2 s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S142.7,402.9,141.3,402.6z M148.9,404.6c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4 c1.4,0.4,2.4-0.5,2.4-2S150.3,405,148.9,404.6z M156.6,406.7c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2 C159,408.5,157.9,407,156.6,406.7z M164.2,408.7c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2S165.6,409.1,164.2,408.7z  M171.8,410.8c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S173.2,411.1,171.8,410.8z M179.5,412.8 c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S180.8,413.2,179.5,412.8z M187.1,414.9c-1.4-0.4-2.4,0.5-2.4,2 s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S188.5,415.3,187.1,414.9z M194.7,416.9c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2 S196.1,417.3,194.7,416.9z M202.4,419c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2S203.7,419.4,202.4,419z M210,421.1 c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S211.4,421.4,210,421.1z M217.6,423.1c-1.4-0.4-2.4,0.5-2.4,2 s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S219,423.5,217.6,423.1z M225.3,425.2c-1.4-0.4-2.4,0.5-2.4,2c0,1.5,1.1,3,2.4,3.4 s2.4-0.5,2.4-2S226.6,425.5,225.3,425.2z M232.9,427.2c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2 S234.3,427.6,232.9,427.2z M240.6,429.3c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S241.9,429.6,240.6,429.3z  M248.2,431.3c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S249.5,431.7,248.2,431.3z M255.8,408.4 c-1.4-0.4-2.4,0.5-2.4,2c0,1.5,1.1,3,2.4,3.4s2.4-0.5,2.4-2C258.3,410.3,257.2,408.8,255.8,408.4z M263.5,410.5 c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S264.8,410.8,263.5,410.5z M255.8,416.7c-1.4-0.4-2.4,0.5-2.4,2 s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S257.2,417.1,255.8,416.7z M263.5,418.8c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4 c1.4,0.4,2.4-0.5,2.4-2S264.8,419.2,263.5,418.8z M255.8,425.1c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4s2.4-0.5,2.4-2 S257.2,425.4,255.8,425.1z M263.5,427.1c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S264.8,427.5,263.5,427.1z  M255.8,433.4c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S257.2,433.7,255.8,433.4z M263.5,435.4 c-1.4-0.4-2.4,0.5-2.4,2s1.1,3,2.4,3.4c1.4,0.4,2.4-0.5,2.4-2S264.8,435.8,263.5,435.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.4243,
    y1: 128.3391,
    x2: 196.767,
    y2: 142.2414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M109.5,118.9c0-5.3,2.8-10.1,7.4-12.8l171.4,45.2c-5.1,2.9-8.2,8.3-8.2,14.2L109.5,118.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "H",
    className: "st0"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 144.6,
    y1: 13.6,
    x2: 144.6,
    y2: 630.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 250.7,
    y1: 17.9,
    x2: 250.7,
    y2: 635
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 239.3,
    y1: 17.9,
    x2: 239.3,
    y2: 635
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 156.1,
    y1: -5.1,
    x2: 156.1,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 266.6,
    y1: 17.9,
    x2: 266.6,
    y2: 635
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 326.1,
    y1: -27.4,
    x2: 326.1,
    y2: 589.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 314.6,
    y1: -27.4,
    x2: 314.6,
    y2: 589.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: -50.8,
    y1: 288.6,
    x2: 540.5,
    y2: -52.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: -26.7,
    y1: 461.1,
    x2: 564.7,
    y2: 119.7
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: -28,
    y1: 427.6,
    x2: 563.4,
    y2: 86.1
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: -53.9,
    y1: 459.8,
    x2: 537.5,
    y2: 118.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: -10.4,
    y1: 505.2,
    x2: 581,
    y2: 163.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 45.9,
    y1: 316.6,
    x2: 637.3,
    y2: -24.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 56.4,
    y1: 496.9,
    x2: 647.8,
    y2: 155.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 56.8,
    y1: 502.6,
    x2: 648.2,
    y2: 161.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 56.4,
    y1: 489.2,
    x2: 647.8,
    y2: 147.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 35.1,
    y1: 312.8,
    x2: 626.5,
    y2: -28.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 88.2,
    y1: 324.5,
    x2: 679.6,
    y2: -16.9
  })), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: -562.6,
    y1: -77.5,
    x2: 1277.6,
    y2: 415.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: -762.6,
    y1: 65.2,
    x2: 1077.6,
    y2: 558.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: -770.6,
    y1: -70.8,
    x2: 1069.6,
    y2: 422.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerrychefeikonE2S);
export default __webpack_public_path__ + "static/media/MerrychefeikonE2S.2a63a94386117a305aadd8643013b879.svg";
export { ForwardRef as ReactComponent };